import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgContacts = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M6.82231 8.99922C6.82231 7.37699 8.13732 6.06198 9.75954 6.06198C11.3818 6.06198 12.6968 7.37699 12.6968 8.99922C12.6968 10.6214 11.3818 11.9365 9.75954 11.9365C8.13732 11.9365 6.82231 10.6214 6.82231 8.99922ZM9.75954 7.37448C8.86219 7.37448 8.13481 8.10186 8.13481 8.99922C8.13481 9.89657 8.86219 10.624 9.75954 10.624C10.6569 10.624 11.3843 9.89657 11.3843 8.99922C11.3843 8.10186 10.6569 7.37448 9.75954 7.37448Z",
			fill: "white",
			fillOpacity: .74
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M6.73124 16.4984H14.3215C15.5238 16.4984 16.4984 15.5238 16.4984 14.3215V3.67691C16.4984 2.47464 15.5238 1.5 14.3215 1.5H5.19757C3.99529 1.5 3.02066 2.47464 3.02066 3.67691V4.54132H2.15625C1.79381 4.54132 1.5 4.83513 1.5 5.19757C1.5 5.56 1.79381 5.85382 2.15625 5.85382H3.02066V8.34297H2.15625C1.79381 8.34297 1.5 8.63678 1.5 8.99922C1.5 9.36165 1.79381 9.65547 2.15625 9.65547H3.02066V12.1446H2.15625C1.79381 12.1446 1.5 12.4384 1.5 12.8009C1.5 13.1633 1.79381 13.4571 2.15625 13.4571H3.02066V14.3215C3.02066 15.5238 3.9953 16.4984 5.19757 16.4984H6.7067C6.71491 16.4986 6.72309 16.4986 6.73124 16.4984ZM5.19757 2.8125C4.72017 2.8125 4.33316 3.19951 4.33316 3.67691V14.3215C4.33316 14.7989 4.72016 15.1859 5.19757 15.1859H6.19615C6.3947 14.4804 6.72148 13.9086 7.26794 13.5125C7.92525 13.0361 8.7803 12.9049 9.75954 12.9049C10.7318 12.9049 11.5863 13.0245 12.2442 13.4884C12.8049 13.8838 13.1353 14.4638 13.3333 15.1859H14.3215C14.7989 15.1859 15.1859 14.7989 15.1859 14.3215V3.67691C15.1859 3.1995 14.7989 2.8125 14.3215 2.8125H5.19757ZM11.9511 15.1859C11.8214 14.8718 11.6636 14.685 11.4878 14.5611C11.1773 14.3421 10.6729 14.2174 9.75954 14.2174C8.85318 14.2174 8.34931 14.3497 8.03823 14.5752C7.86517 14.7006 7.71044 14.8859 7.58247 15.1859H11.9511Z",
			fill: "white",
			fillOpacity: .74
		})
	]
});
const ForwardRef = forwardRef(SvgContacts);
export { ForwardRef as ReactComponent };
